{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Tempel",
    "pasteAsPlaintext": "Tempel sebagai teks biasa",
    "pasteCharts": "Tempel diagram",
    "chartType_bar": "Diagram batang",
    "chartType_line": "Diagram garis",
    "chartType_radar": "Diagram radar",
    "chartType_plaintext": "Teks biasa",
    "selectAll": "Pilih semua",
    "multiSelect": "Tambah unsur ke seleksi",
    "moveCanvas": "Pindahkan kanvas",
    "cut": "Potong",
    "copy": "Salin",
    "copyAsPng": "Salin ke papan klip sebagai PNG",
    "copyAsSvg": "Salin ke papan klip sebagai SVG",
    "copyText": "Salin ke papan klip sebagai teks",
    "copySource": "Salin sumber ke papan klip",
    "convertToCode": "Konversi ke kode",
    "bringForward": "Bawa maju",
    "sendToBack": "Kirim ke belakang",
    "bringToFront": "Bawa ke depan",
    "sendBackward": "Kirim mundur",
    "delete": "Hapus",
    "copyStyles": "Salin gaya",
    "pasteStyles": "Tempelkan gaya",
    "stroke": "Guratan",
    "changeStroke": "Ubah warna garis",
    "background": "Latar",
    "changeBackground": "Ubah warna background",
    "fill": "Isian",
    "strokeWidth": "Lebar guratan",
    "strokeStyle": "Gaya guratan",
    "strokeStyle_solid": "Padat",
    "strokeStyle_dashed": "Putus-putus",
    "strokeStyle_dotted": "Titik-titik",
    "sloppiness": "Kecerobohan",
    "pressure": "Tekanan",
    "pressure_constant": "Konstan",
    "pressure_variable": "Variabel",
    "opacity": "Keburaman",
    "textAlign": "Perataan teks",
    "edges": "Tepi",
    "sharp": "Tajam",
    "round": "Bulat",
    "arrowheads": "Mata panah",
    "arrowhead_none": "Tidak ada",
    "arrowhead_arrow": "Panah",
    "arrowhead_bar": "Batang",
    "arrowhead_circle": "Lingkaran",
    "arrowhead_circle_outline": "Lingkaran (garis)",
    "arrowhead_triangle": "Segitiga",
    "arrowhead_triangle_outline": "Segitiga (garis)",
    "arrowhead_diamond": "Diamond",
    "arrowhead_diamond_outline": "Diamond (garis)",
    "arrowhead_crowfoot_many": "Notasi kaki gagak (banyak)",
    "arrowhead_crowfoot_one": "Notasi kaki gagak (satu)",
    "arrowhead_crowfoot_one_or_many": "Notasi kaki gagak (satu atau banyak)",
    "arrowhead_cardinality_one": "kardinalitas (satu)",
    "arrowhead_cardinality_many": "kardinalitas (banyak)",
    "arrowhead_cardinality_one_or_many": "kardinalitas (satu atau banyak)",
    "arrowhead_cardinality_exactly_one": "kardinalitas (tepat satu)",
    "arrowhead_cardinality_zero_or_one": "kardinalitas (nol atau tidak ada)",
    "arrowhead_cardinality_zero_or_many": "kardinalitas (nol atau banyak)",
    "more_options": "Pilihan lain",
    "cardinality": "kardinalitas ",
    "arrowtypes": "Jenis panah",
    "arrowtype_sharp": "Panah runcing",
    "arrowtype_round": "Panah melengkung",
    "arrowtype_elbowed": "Panah siku",
    "fontSize": "Ukuran font",
    "fontFamily": "Jenis font",
    "addWatermark": "Tambahkan \"Dibuat dengan Excalidraw\"",
    "handDrawn": "Tulisan tangan",
    "normal": "Normal",
    "code": "Kode",
    "small": "Kecil",
    "medium": "Sedang",
    "large": "Besar",
    "veryLarge": "Sangat besar",
    "solid": "Padat",
    "hachure": "Garis-garis",
    "zigzag": "Bentuk Z",
    "crossHatch": "Asiran silang",
    "thin": "Lembut",
    "bold": "Tebal",
    "left": "Kiri",
    "center": "Tengah",
    "right": "Kanan",
    "extraBold": "Sangat tebal",
    "architect": "Arsitek",
    "artist": "Artis",
    "cartoonist": "Kartunis",
    "fileTitle": "Nama file",
    "colorPicker": "Pilihan Warna",
    "canvasColors": "Digunakan di kanvas",
    "canvasBackground": "Latar Kanvas",
    "drawingCanvas": "Kanvas",
    "clearCanvas": "Hapus kanvas",
    "layers": "Lapisan",
    "actions": "Aksi",
    "language": "Bahasa",
    "liveCollaboration": "Kolaborasi langsung...",
    "duplicateSelection": "Duplikat",
    "untitled": "Tanpa judul",
    "name": "Nama",
    "yourName": "Nama Anda",
    "madeWithExcalidraw": "Dibuat dengan Excalidraw",
    "group": "Kelompokan pilihan",
    "ungroup": "Pisahkan pilihan",
    "collaborators": "Kolaborator",
    "you": "Kamu",
    "toggleGrid": "Toggle grid",
    "loadingScene": "Memuat pemandangan…",
    "loadScene": "Muat dari file",
    "align": "Perataan",
    "alignTop": "Rata atas",
    "alignBottom": "Rata bawah",
    "alignLeft": "Rata kiri",
    "alignRight": "Rata kanan",
    "centerVertically": "Pusatkan secara vertikal",
    "centerHorizontally": "Pusatkan secara horizontal",
    "distributeHorizontally": "Distribusikan horizontal",
    "distributeVertically": "Distribusikan vertikal",
    "flipHorizontal": "Balikkan horizontal",
    "flipVertical": "Balikkan vertikal",
    "viewMode": "Mode tampilan",
    "share": "Bagikan",
    "showStroke": "Tampilkan garis pengambil warna",
    "showBackground": "Tampilkan latar pengambil warna",
    "showFonts": "Tampilkan pilihan warna",
    "toggleTheme": "Toggle tema terang/gelap",
    "theme": "Tema",
    "decreaseFontSize": "Kecilkan ukuran font",
    "increaseFontSize": "Besarkan ukuran font",
    "unbindText": "Lepas teks",
    "bindText": "Kunci teks ke kontainer",
    "createContainerFromText": "Bungkus teks dalam kontainer",
    "link": {
      "edit": "Edit tautan",
      "editEmbed": "Sunting tautan bisa semat",
      "create": "Tambah tautan",
      "label": "Tautan",
      "labelEmbed": "Tautan & sematan",
      "empty": "Tidak ada tautan yang ditetapkan",
      "hint": "Ketik atau tempel tautan di sini",
      "goToElement": "Ke unsur sasaran"
    },
    "lineEditor": {
      "edit": "Edit tautan",
      "editArrow": "Ubah Panah"
    },
    "polygon": {
      "breakPolygon": "Pecah poligon",
      "convertToPolygon": "Konversi ke poligon"
    },
    "elementLock": {
      "lock": "Kuncikan",
      "unlock": "Lepas",
      "lockAll": "Kuncikan semua",
      "unlockAll": "Lepas semua"
    },
    "sidebarLock": "Biarkan sidebar tetap terbuka",
    "selectAllElementsInFrame": "Pilih semua unsur di bingkai",
    "removeAllElementsFromFrame": "Hapus semua unsur dari bingkai",
    "eyeDropper": "Ambil warna dari kanvas",
    "followUs": "Ikuti kami",
    "discordChat": "Obrolan Discord",
    "zoomToFitViewport": "Perbesar agar sesuai dengan viewport",
    "zoomToFitSelection": "Memperbesar agar sesuai dengan pilihan",
    "zoomToFit": "Memperbesar agar unsur pas semua",
    "installPWA": "Install Excalidraw secara lokal (PWA)",
    "autoResize": "Mengaktifkan pengubahan ukuran teks secara otomatis",
    "imageCropping": "Pemangkasan gambar",
    "unCroppedDimension": "Dimensi yang tidak dipotong",
    "copyElementLink": "Salin tautan ke objek",
    "linkToElement": "Taut ke objek",
    "wrapSelectionInFrame": "Bungkus pilihan dalam bingkai",
    "tab": "Tab",
    "shapeSwitch": "Keputusan",
    "preferences": "Preferensi",
    "preferences_toolLock": "Kunci alat",
    "boxSelectionMode": "Pilih pada",
    "boxSelectionContain": "Cakup penuh",
    "boxSelectionOverlap": "Tumpang tindih",
    "arrowBinding": "Pengikatan anak panah",
    "midpointSnapping": "Rapatkan ke titik tengah"
  },
  "elementLink": {
    "title": "Taut ke objek",
    "desc": "Pencet bentuk pada kanvas atau tempel tautan.",
    "notFound": "Objek tertaut tidak ditemukan di kanvas."
  },
  "search": {
    "title": "Temukan di kanvas",
    "noMatch": "Tidak ada kecocokan yang ditemukan...",
    "singleResult": "hasil",
    "multipleResults": "semua hasil",
    "placeholder": "Temukan teks di kanvas...",
    "frames": "Bingkai",
    "texts": "Teks"
  },
  "buttons": {
    "clearReset": "Setel Ulang Kanvas",
    "exportJSON": "Ekspor ke file",
    "exportImage": "Ekspor gambar...",
    "export": "Simpan ke...",
    "copyToClipboard": "Salin ke Papan Klip",
    "copyLink": "Salin tautan",
    "save": "Simpan ke file sekarang",
    "saveAs": "Simpan sebagai",
    "load": "Buka",
    "getShareableLink": "Buat Tautan yang Bisa Dibagian",
    "close": "Tutup",
    "selectLanguage": "Pilih bahasa",
    "scrollBackToContent": "Gulir kembali ke konten",
    "zoomIn": "Besarkan",
    "zoomOut": "Kecilkan",
    "resetZoom": "Reset Pembesaran",
    "menu": "Menu",
    "done": "Selesai",
    "edit": "Sunting",
    "undo": "Urungkan",
    "redo": "Ulangi",
    "createNewRoom": "Buat ruang baru",
    "fullScreen": "Layar penuh",
    "darkMode": "Mode gelap",
    "lightMode": "Mode terang",
    "systemMode": "Mode sistem",
    "zenMode": "Mode zen",
    "objectsSnapMode": "Snap to objects",
    "exitZenMode": "Keluar dari mode zen",
    "cancel": "Batal",
    "clear": "Hapus",
    "remove": "Hapus",
    "embed": "Mati/nyala penyematan",
    "submit": "Kirimkan",
    "confirm": "Konfirmasi",
    "embeddableInteractionButton": "Pencet untuk interaksi"
  },
  "alerts": {
    "clearReset": "Ini akan menghapus semua yang ada dikanvas. Apakah kamu yakin ?",
    "couldNotCreateShareableLink": "Tidak bisa membuat tautan yang bisa dibagikan",
    "couldNotCreateShareableLinkTooBig": "Tidak dapat membuat tautan yang dapat dibagikan: pemandangan terlalu besar",
    "couldNotLoadInvalidFile": "Tidak dapat memuat berkas yang tidak valid",
    "importBackendFailed": "Gagal mengimpor dari backend",
    "cannotExportEmptyCanvas": "Tidak bisa mengekspor kanvas kosong",
    "couldNotCopyToClipboard": "Tidak bisa menyalin ke papan klip.",
    "decryptFailed": "Tidak dapat mengdekripsi data.",
    "uploadedSecurly": "Pengunggahan ini telah diamankan menggunakan enkripsi end-to-end, artinya server Excalidraw dan pihak ketiga tidak data membaca nya",
    "loadSceneOverridePrompt": "Memuat gambar external akan mengganti konten Anda yang ada. Apakah Anda ingin melanjutkan?",
    "collabStopOverridePrompt": "Menghentikan sesi akan menimpa gambar Anda yang tersimpan secara lokal. Anda yakin?\n\n(Jika Anda ingin menyimpan gambar lokal Anda, gantinya cukup tutup tab browser.)",
    "imageDoesNotContainScene": "Gambar ini tampaknya tidak ada data pemandangan. Apakah penyematan pemandangan sudah diaktifkan saat ekspor?",
    "cannotRestoreFromImage": "Pemandangan tidak dapat dipulihkan dari file gambar ini",
    "invalidSceneUrl": "Tidak dapat impor pemandangan dari URL. Kemungkinan URL itu rusak atau tidak berisi data JSON Excalidraw yang valid.",
    "invalidEncryptionKey": "Sandi enkripsi harus 22 karakter. Kolaborasi langsung dinonaktifkan.",
    "collabOfflineWarning": "Tidak ada koneksi internet.\nPerubahan tidak akan disimpan!",
    "localStorageQuotaExceeded": "Kuota penyimpanan browser telah terlampaui. Perubahan tidak akan disimpan."
  },
  "errors": {
    "unsupportedFileType": "Tipe file tidak didukung.",
    "imageInsertError": "Tidak dapat menyisipkan gambar. Coba lagi nanti...",
    "fileTooBig": "File terlalu besar. Ukuran maksimum yang dibolehkan {{maxSize}}.",
    "svgImageInsertError": "Tidak dapat menyisipkan gambar SVG. Markup SVG sepertinya tidak valid.",
    "failedToFetchImage": "Gagal memuat gambar.",
    "cannotResolveCollabServer": "Tidak dapat terhubung ke server kolab. Muat ulang laman dan coba lagi.",
    "collabSaveFailed": "Tidak dapat menyimpan ke dalam basis data server. Jika masih berlanjut, Anda sebaiknya simpan berkas Anda secara lokal untuk memastikan pekerjaan Anda tidak hilang.",
    "collabSaveFailed_sizeExceeded": "Tidak dapat menyimpan ke dalam basis data server, tampaknya ukuran kanvas terlalu besar. Anda sebaiknya simpan berkas Anda secara lokal untuk memastikan pekerjaan Anda tidak hilang.",
    "imageToolNotSupported": "Gambar dinonaktifkan.",
    "brave_measure_text_error": {
      "line1": "Sepertinya Anda menggunkan peramban Brave dengan pengaturan <bold>Blokir Fingerprinting yang Agresif</bold> diaktifkan.",
      "line2": "Ini dapat merusak <bold>Unsur Teks</bold> pada gambarmu.",
      "line3": "Kami sangat menyarankan mematikan pengaturan ini. Anda dapat mengikuti <link>langkah-langkah ini</link> untuk melakukannya.",
      "line4": "Jika mematikan pengaturan ini tidak memperbaiki unsur teks, silakan buka <issueLink>issue</issueLink> di GitHub kami, atau hubungi kami di <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Tidak dapat menempel (tidak dapat membaca dari papan klip sistem).",
    "asyncPasteFailedOnParse": "Tidak dapat menempel.",
    "copyToSystemClipboardFailed": "Tidak bisa menyalin ke papan klip."
  },
  "toolBar": {
    "selection": "Pilihan",
    "lasso": "Seleksi lasso",
    "image": "Sisipkan gambar",
    "rectangle": "Persegi",
    "diamond": "Berlian",
    "ellipse": "Elips",
    "arrow": "Panah",
    "line": "Garis",
    "freedraw": "Gambar",
    "text": "Teks",
    "lock": "Biarkan alat yang dipilih aktif setelah menggambar",
    "penMode": "Mode pena - mencegah sentuhan",
    "link": "Tambah/Perbarui tautan untuk bentuk yang dipilih",
    "eraser": "Penghapus",
    "frame": "Alat bingkai",
    "embeddable": "Sematan Web",
    "laser": "Penunjuk laser",
    "autoshape": "Gambar ke bentuk",
    "bucketfill": "Isi warna (Ember)",
    "hand": "Tangan (alat panning)",
    "extraTools": "Alat-alat lain",
    "convertElementType": "Beralih jenis bentuk"
  },
  "bucketfill": {
    "noRegion": "Tidak dapat menemukan area tertutup untuk diisi",
    "tooComplex": "Area ini terlalu rumit untuk diisi"
  },
  "element": {
    "rectangle": "Persegi Panjang",
    "diamond": "Wajik",
    "ellipse": "Elips",
    "arrow": "Panah",
    "line": "Garis",
    "freedraw": "Gambar bebas",
    "text": "Teks",
    "image": "Gambar",
    "group": "Kelompok",
    "frame": "Bingkai",
    "embeddable": "Sematan Web",
    "selection": "Seleksi",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Opsi Kanvas",
    "selectedShapeActions": "Opsi bentuk yang dipilih",
    "shapes": "Bentuk"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} untuk menutup pencarian.",
    "canvasPanning": "Untuk menggeser kanvas, tahan {{shortcut_1}} atau {{shortcut_2}} sambil menyeret, atau gunakan alat tangan",
    "linearElement": "Pencet untuk membuat titik-titik, seret untuk satu garis",
    "arrowTool": "Klik untuk memulai banyak titik, seret untuk satu garis. Tekan {{shortcut}} lagi untuk mengubah jenis anak panah.",
    "arrowBindModifiers": "Tahan {{shortcut_1}} untuk menonaktifkan pengikatan, atau {{shortcut_2}} untuk mengikat pada titik tetap",
    "freeDraw": "Klik dan seret, lepaskan jika Anda selesai",
    "text": "Tip: Anda juga dapat menambahkan teks dengan klik ganda di mana saja dengan alat pemilihan",
    "embeddable": "Pencet-seret untuk membuat sematan situs",
    "autoshape": "Gambar persegi panjang, lingkaran, belah ketupat, garis, dan anak panah",
    "text_selected": "Klik dua kali atau tekan {{shortcut}} untuk mengedit teks",
    "text_editing": "Tekan {{shortcut_1}} atau {{shortcut_2}} untuk menyelesaikan pengeditan",
    "linearElementMulti": "Klik pada titik terakhir atau tekan {{shortcut_1}} atau {{shortcut_2}} untuk selesai",
    "lockAngle": "Anda dapat mengunci sudut dengan menahan {{shortcut}}",
    "resize": "Anda dapat menjaga proporsi dengan menahan {{shortcut_1}} saat mengubah ukuran, tahan {{shortcut_2}} untuk mengubah ukuran dari pusat",
    "resizeImage": "Anda dapat mengubah ukuran secara bebas dengan menahan {{shortcut_1}} , tahan {{shortcut_2}} untuk mengubah ukuran dari pusat",
    "rotate": "Anda dapat mengunci sudut dengan menahan {{shortcut}} saat memutar",
    "toggleArrowhead": "Klik dua kali untuk beralih mata panah",
    "lineEditor_info": "Tahan {{shortcut_1}} lalu klik dua kali atau tekan {{shortcut_2}} untuk mengedit titik",
    "lineEditor_line_info": "Klik dua kali atau tekan {{shortcut}} untuk mengedit titik",
    "lineEditor_pointSelected": "Tekan {{shortcut_1}} untuk menghapus titik, {{shortcut_2}} untuk menggandakan, atau seret untuk memindahkan",
    "lineEditor_nothingSelected": "Pilih titik untuk mengedit (tahan {{shortcut_1}} untuk memilih beberapa), atau tahan {{shortcut_2}} dan klik untuk menambahkan titik baru",
    "bindTextToElement": "{{shortcut}} untuk menambahkan teks",
    "createFlowchart": "{{shortcut}} untuk membuat diagram alir",
    "deepBoxSelect": "Tahan {{shortcut}} untuk memilih tingkat dalam, dan untuk mencegah pergeseran",
    "eraserRevert": "Tahan {{shortcut}} untuk mengembalikan elemen yang ditandai untuk dihapus",
    "firefox_clipboard_write": "Fitur ini dapat diaktifkan melalui pengaturan flag \"dom.events.asyncClipboard.clipboardItem\" ke \"true\". Untuk mengganti flag di Firefox, pergi ke laman \"about:config\".",
    "disableSnapping": "Tahan {{shortcut}} untuk menonaktifkan penambatan (snapping)",
    "enterCropEditor": "Klik dua kali gambar atau tekan {{shortcut}} untuk memotong gambar",
    "leaveCropEditor": "Klik di luar gambar atau tekan {{shortcut_1}} atau {{shortcut_2}} untuk menyelesaikan pemotongan"
  },
  "canvasError": {
    "cannotShowPreview": "Tidak dapat menampilkan pratinjau",
    "canvasTooBig": "Kanvas mungkin terlalu besar.",
    "canvasTooBigTip": "Kiat: coba pindahkan unsur terjauh lebih dekat lagi."
  },
  "errorSplash": {
    "headingMain": "Mengalami sebuah kesalahan. Cobalah <button>muat ulang halaman.</button>",
    "clearCanvasMessage": "Jika memuat ulang tidak bekerja, cobalah <button>bersihkan canvas.</button>",
    "clearCanvasCaveat": " Ini akan menghasilkan hilangnya pekerjaan ",
    "trackedToSentry": "Kesalahan dengan pengidentifikasi {{eventId}} dilacak di sistem kami.",
    "openIssueMessage": "Kami sangat berhati-hati untuk tidak menyertakan informasi pemandangan Anda pada kesalahan. Jika pemandangan Anda tidak bersifat pribadi, mohon pertimbangkan menindak lanjut pada <button>pelacak bug.</button> Mohon sertakan informasi dibawah ini dengan menyalin dan menempelkan di Github issue.",
    "sceneContent": "Pemandangan konten:"
  },
  "shareDialog": {
    "or": "Atau"
  },
  "roomDialog": {
    "desc_intro": "Ajak orang-orang ikut menggambar denganmu.",
    "desc_privacy": "Tenang, sesi ini terenkripsi ujung-ke-ujung, sepenuhnya privat. Bahkan gambarmu tidak terlihat server kami.",
    "button_startSession": "Mulai sesi",
    "button_stopSession": "Hentikan sesi",
    "desc_inProgressIntro": "Sesi kolaborasi sedang berlangsung sekarang.",
    "desc_shareLink": "Bagikan tautan ini dengan siapa pun yang Anda inginkan untuk kolaborasi bersama:",
    "desc_exitSession": "Menghentikan sesi akan memutuskan hubungan Anda dari ruangan, tetapi Anda dapat melanjutkan bekerja dengan pemandangan Anda secara lokal. Perhatikan bahwa ini tidak memengaruhi orang lain, dan mereka masih dapat berkolaborasi pada versi mereka.",
    "shareTitle": "Gabung sesi kolaborasi langsung di Excalidraw"
  },
  "errorDialog": {
    "title": "Kesalahan"
  },
  "progressDialog": {
    "title": "Menyimpan",
    "defaultMessage": "Menyiapkan untuk menyimpan..."
  },
  "exportDialog": {
    "disk_title": "Simpan ke disk",
    "disk_details": "Ekspor data pemandangan ke file yang mana Anda dapat impor nanti.",
    "disk_button": "Simpan ke file",
    "link_title": "Tautan",
    "link_details": "Ekspor sebagai tautan yang hanya dibaca.",
    "link_button": "Ekspor ke tautan",
    "excalidrawplus_description": "Simpan pemandangan ke ruang kerja Excalidraw+ Anda.",
    "excalidrawplus_button": "Ekspor",
    "excalidrawplus_exportError": "Tidak dapat ekspor ke Excalidraw+ saat ini..."
  },
  "helpDialog": {
    "blog": "Baca blog kami",
    "click": "klik",
    "deepSelect": "Pilih dalam",
    "deepBoxSelect": "Pilih dalam kotak, dan cegah penggeseran",
    "createFlowchart": "Buat bagan alir dari unsur generik",
    "navigateFlowchart": "Menavigasi bagan alir",
    "curvedArrow": "Panah lengkung",
    "curvedLine": "Garis lengkung",
    "documentation": "Dokumentasi",
    "doubleClick": "klik-ganda",
    "drag": "seret",
    "editor": "Penyunting",
    "editLineArrowPoints": "Edit titik garis/panah",
    "editText": "Edit teks / tambah label",
    "github": "Menemukan masalah? Kirimkan",
    "howto": "Ikuti panduan kami",
    "or": "atau",
    "preventBinding": "Cegah pengikatan panah",
    "tools": "Alat",
    "shortcuts": "Pintasan keyboard",
    "textFinish": "Selesai mengedit (editor teks)",
    "textNewLine": "Tambahkan garis baru (editor teks)",
    "title": "Bantuan",
    "view": "Tampilan",
    "zoomToFit": "Memperbesar agar unsur pas semua",
    "zoomToSelection": "Perbesar ke seleksi",
    "toggleElementLock": "Lepas/kuncikan seleksi",
    "movePageUpDown": "Pindah halaman keatas/kebawah",
    "movePageLeftRight": "Pindah halaman kebawah/keatas",
    "cropStart": "Pangkas gambar",
    "cropFinish": "Sudahi pangkas gambar"
  },
  "clearCanvasDialog": {
    "title": "Hapus kanvas"
  },
  "imageExportDialog": {
    "header": "Ekspor gambar",
    "label": {
      "withBackground": "Latar",
      "onlySelected": "Hanya yang dipilih",
      "darkMode": "Mode gelap",
      "embedScene": "Sematkan pemandangan",
      "scale": "Skala",
      "padding": "Lapisan"
    },
    "tooltip": {
      "embedScene": "Data pemandangan akan diekspor ke bentuk PNG/SVG sehingga pemandangan dapat dipulihkan darinya.\nUkuran berkas ekspor akan membesar."
    },
    "title": {
      "exportToPng": "Ekspor ke PNG",
      "exportToSvg": "Ekspor ke SVG",
      "copyPngToClipboard": "Salin PNG ke papan klip"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Salin ke papan klip"
    }
  },
  "encrypted": {
    "tooltip": "Gambar anda terenkripsi end-to-end sehingga server Excalidraw tidak akan pernah dapat melihatnya.",
    "link": "Pos blog tentang enkripsi ujung ke ujung di Excalidraw"
  },
  "stats": {
    "angle": "Sudut",
    "shapes": "Bentuk",
    "height": "Tinggi",
    "scene": "Pemandangan",
    "selected": "Terpilih",
    "storage": "Penyimpanan",
    "fullTitle": "Properti Kanvas & Bentuk",
    "title": "Properti",
    "generalStats": "Umum",
    "elementProperties": "Properti bentuk",
    "total": "Jumlah",
    "version": "Versi",
    "versionCopy": "Klik untuk salin",
    "versionNotAvailable": "Versi tidak tersedia",
    "width": "Lebar"
  },
  "toast": {
    "copyStyles": "Gaya tersalin.",
    "copyToClipboard": "Tersalin ke papan klip.",
    "copyToClipboardAsPng": "Tersalin {{exportSelection}} ke clipboard sebagai PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} tersalin ke papan klip sebagai SVG\n({{exportColorScheme}})",
    "fileSaved": "File tersimpan.",
    "fileSavedToFilename": "Disimpan ke {filename}",
    "canvas": "kanvas",
    "selection": "pilihan",
    "pasteAsSingleElement": "Gunakan {{shortcut}} untuk menempel unsur tunggal,\natau tempel ke penyunting teks",
    "unableToEmbed": "Menyemat URL ini saat ini tidak boleh. Ajukan \"Issue\" di GitHub untuk meminta URL masuk daftar putih",
    "unrecognizedLinkFormat": "Tautan yang disematkan tidak sesuai dengan syarat format. Coba tempel untaian 'embed' (semat) yang disediakan situs sumber",
    "elementLinkCopied": "Tautan disalin ke papan klip"
  },
  "colors": {
    "transparent": "Transparan",
    "black": "Hitam",
    "white": "Putih",
    "red": "Merah",
    "pink": "Pink",
    "grape": "Ungu",
    "violet": "Violet",
    "gray": "Abu-abu",
    "blue": "Biru",
    "cyan": "Cyan",
    "teal": "Teal",
    "green": "Hijau",
    "yellow": "Kuning",
    "orange": "Jingga",
    "bronze": "Tembaga"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Gambar anda disimpan di penyimpanan browser anda.",
      "center_heading_line2": "Penyimpanan browser dapat terhapus secara tidak terduga.",
      "center_heading_line3": "Simpan pekerjaan anda ke file secara berkala agar tidak hilang.",
      "center_heading_plus": "Apa Anda ingin berpindah ke Excalidraw+?",
      "menuHint": "Ekspor, preferensi, bahasa, ..."
    },
    "defaults": {
      "menuHint": "Ekspor, preferensi, dan selebihnya...",
      "center_heading": "Diagram. Menjadi. Mudah.",
      "toolbarHint": "Pilih alat & mulai menggambar!",
      "helpHint": "Pintasan & bantuan"
    }
  },
  "colorPicker": {
    "color": "Warna",
    "mostUsedCustomColors": "Warna yang sering dipakai",
    "colors": "Warna",
    "shades": "Nuansa",
    "hexCode": "Kode hexa",
    "noShades": "Tidak ada nuansa untuk warna ini",
    "invalidColor": "Bukan warna yang valid",
    "invalidHexLength": "Kode Hex harus 3, 4, 6, atau 8 karakter",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Ekspor sebagai gambar",
        "button": "Ekspor sebagai gambar",
        "description": "Ekspor data pemandangan sebagai gambar yang dapat anda impor nanti."
      },
      "saveToDisk": {
        "title": "Simpan ke disk",
        "button": "Simpan ke disk",
        "description": "Ekspor data pemandangan ke file yang dapat Anda dapat impor nanti."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Ekspor ke Excalidraw+",
        "description": "Simpan pemandangan ke ruang kerja Excalidraw+ Anda."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Muat dari file",
        "button": "Muat dari file",
        "description": "Memuat dari file yang akan <bold>menggantikan konten Anda sekarang</bold>.<br></br>Anda dapat mencadangkan gambar anda dulu menggunakan opsi-opsi ini."
      },
      "shareableLink": {
        "title": "Muat dari link",
        "button": "Ganti konten saya",
        "description": "Memuat dari file yang akan <bold>menggantikan konten Anda sekarang</bold>.<br></br>Anda dapat mencadangkan gambar anda dulu menggunakan opsi-opsi ini."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Pencarian Cepat"
  },
  "fontList": {
    "badge": {
      "old": "lebih lama"
    },
    "sceneFonts": "Pada layar ini",
    "availableFonts": "Font yang tersedia",
    "empty": "Tidak ada font yang ditemukan"
  },
  "userList": {
    "empty": "Tidak ada pengguna yang ditemukan",
    "hint": {
      "text": "Klik pada pengguna untuk mengikuti",
      "followStatus": "Anda saat ini mengikuti pengguna ini",
      "inCall": "Pengguna sedang dalam panggilan telephon",
      "micMuted": "Mikrofon user sedang dimatikan",
      "isSpeaking": "Pengguna sedang berbicara"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Spasi",
    "delete": "Hapus",
    "mmb": "Roda gulir"
  }
}
